var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"progressBar",style:({ height: `${_vm.heightBar}px`, 'border-radius': `${_vm.radiusBar}px` })},[_c('div',{staticClass:"progressBar progressBar--fill",style:({ width: `${_vm.widthBar}%`, 'border-radius': `${_vm.radiusBar}px`, background: _vm.colorFill })})])
}
var staticRenderFns = []

export { render, staticRenderFns }